export enum MailType {
  Legitimation = 0,
  Intyg = 1,
  SkyddadYrkestitel = 2,
}

//Must match with \Legitimation\Legitimation\Global.cs -> MailTypeFieldName
export const MailTypeFieldName: string = '__mailType';
